// Device service
export const DEVICE_SERVICE_BASE_PATH = '/device-service/devices';
export const DEVICES_BY_SERIAL_NUMBERS_PATH = `${DEVICE_SERVICE_BASE_PATH}/get-devices-by-serial-numbers`;
export const DEVICE_SERVICE_EXPORT_PATH = '/device-service/export';

export const SENSE_DEVICES_BASE_PATH = '/sense';

export const createDevicePath = (manufacturer: string, serialNumber: string) =>
  `${DEVICE_SERVICE_BASE_PATH}/inventory/${manufacturer}/${serialNumber}`;

// Notification rules
export const NOTIFICATION_RULES_BASE_PATH = '/notifications-service/notification-rules';

// Users
export const USERS_BASE_PATH = '/users-service/users';
export const USER_PREFERENCES_PATH = '/preferences';

export const createUserPath = (id: string) => `${USERS_BASE_PATH}/${id}`;

// Verify Phone
export const VERIFY_PHONE_PATH = '/users-service/phone-number-verification';

export const START_VERIFICATION = `${VERIFY_PHONE_PATH}/start`;
export const REPORT_VERIFICATION = `${VERIFY_PHONE_PATH}/report`;

// Configuration

export const APP_CONFIG_BASE_PATH = '/app-config-service';

export const createAppConfigPath = (partial: string) =>
  `${APP_CONFIG_BASE_PATH}/${partial}`;

// Device Events

export const DEVICE_EVENTS_BASE_PATH = '/device-events/device-events';
export const DEVICE_EVENTS_V2_BASE_PATH = '/device-service/device-events';

export const createDeviceEventsPath = (partial: string) =>
  `${DEVICE_EVENTS_BASE_PATH}/${partial}`;

// Licenses

export const LICENSES_BASE_PATH = `/licenses`;

export const createLicensesPath = (filename: string = 'licenses.json') =>
  `${LICENSES_BASE_PATH}/${filename}`;

// Sense Monitors

export const SENSE_MONITORS_BASE_PATH = `/sense/monitors`;

export const createMonitorPath = (monitorId: string, partial: string) =>
  `${SENSE_MONITORS_BASE_PATH}/${encodeURI(monitorId)}/${partial}`;

// Monitoring

export const MONITORING_BASE_PATH = `/monitoring-service`;

// Incidents
export const INCIDENTS_BASE_PATH = '/notifications-service/incidents';

// Audit service
export const AUDIT_BASE_PATH = '/audit-service/audit-events';

// Audit Logs
export const AUDIT_LOGS_BASE_PATH = '/audit-log/commit';

// Reporting service
export const REPORTING_SERVICE_BASE_PATH = '/reporting-service/reports';
export const AUDIT_TRAIL_REPORTS_BASE_PATH = '/reporting-service/reports/audit-trail';
export const RUN_RECORD_REPORTS_BASE_PATH = '/reporting-service/reports/run-record';
export const STABILITY_REPORTS_BASE_PATH = '/reporting-service/reports/stability';

// Ota updates

export const OTA_DEVICES_BASE_PATH = '/ota';

// Subscription
export const SUBSCRIPTION_BASE_PATH = '/subscriptions';

// Settings
export const SETTINGS_BASE_PATH = '/settings';
export const ORGANIZATION_SETTINGS_PATH = `${SETTINGS_BASE_PATH}/organization-settings`;

// Support
export const SUPPORT_BASE_PATH = '/support-service';
export const SUPPORT_CHAT_PATH = `${SUPPORT_BASE_PATH}/request-chat`;
export const SUPPORT_CHAT_FEEDBACK_PATH = `${SUPPORT_BASE_PATH}/chat-feedback`;
export const DASHBOARD_FEEDBACK_PATH = `${SUPPORT_BASE_PATH}/dashboard-feedback`;

// Other

export const LOCALHOST_BASE_URL = 'http://localhost:5173';

export function formatQueryParamsObject(obj: Record<string, unknown>): string[][] {
  return Object.entries(obj)
    .filter(([_, value]) => value !== undefined && value !== null)
    .reduce((prev: string[][], next: [string, unknown]) => {
      const [key, value] = next;
      if (Array.isArray(value)) {
        const urlParam: string[][] = [];
        value.forEach((item) => urlParam.push([key, item]));

        return [...prev, ...urlParam];
      }
      return [...prev, [key, String(value)]];
    }, []);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- any is used for query params
export function objectToURLSearchParams(obj: Record<string, any>) {
  return new URLSearchParams(obj);
}

export const createPathWithQueryParams = (
  basePath: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- any is used for query params
  queryParams: Record<string, any>,
) =>
  `${basePath}?${new URLSearchParams(formatQueryParamsObject(queryParams)).toString()}`;
